import React, { useEffect, useReducer, useState } from 'react';

import LeashLayout from 'leash/components/layout/LeashLayout';
import ArchivedSearchDisplayResultsLabel from 'leash/components/archivedSearchDisplayResultsLabel/ArchivedSearchDisplayResultsLabel';
import ArchivedSearchForm from 'leash/components/archivedSearchForm/ArchivedSearchForm';
import { PageHeaderStyled } from 'leash/components/layout/LeashLayout.styles';
import { PackagesTable } from 'leash/components/packagesTable/PackagesTable';
import {
  packagesInitState,
  packagesReducer,
} from 'leash/reducers/packages/PackagesReducer';
import { useLayoutState } from 'shared/components/layout/useLayoutState';
import { BreadcrumbItem } from 'types';

const breadcrumbs: BreadcrumbItem[] = [
  {
    key: 'main',
    label: 'Main',
    path: '/',
  },
  {
    key: 'leash',
    label: 'Leash',
  },
  {
    key: 'archived',
    label: 'Archived',
  },
];

function Archived() {
  const { dispatch: dispatchLayout } = useLayoutState();
  const [state, dispatch] = useReducer(packagesReducer, packagesInitState);
  const [showResults, setShowResults] = useState(false);

  useEffect(() => {
    dispatchLayout({ type: 'SET_BREADCRUMBS', breadcrumbs });
  }, []);

  return (
    <LeashLayout>
      <PageHeaderStyled
        title="Search for past travel"
        subTitle="Please select a search criteria to get results"
      />
      <ArchivedSearchForm dispatch={dispatch} setShowResults={setShowResults} />
      {showResults && <ArchivedSearchDisplayResultsLabel packagesState={state} />}
      {showResults && <PackagesTable dispatch={dispatch} packagesState={state} />}
    </LeashLayout>
  );
}

export default Archived;
